import src from "IMAGE";
export default { src, width: 656, height: 112, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABQjXFsOGD8+DxpEQhAcSUgQHEtJEBtHRgwVNzYPGUJAXuUFrgiHkQwAAAAASUVORK5CYII="};
